import { createApiHandler } from './handler';

const productionSchedule = {
  apiClient: null,
  path: '/franchises/production-schedule',

  setClient(apiClient) {
    this.apiClient = apiClient;
    this.initApiHandler();
  },

  initApiHandler() {
    Object.assign(this, createApiHandler(this.apiClient, this.path));
  },

  async getByDeliveryDate(branchId, deliveryDate) {
    try {
      const response = await this.apiClient.get(
        `${this.path}/branch/${branchId}?delivery_date=${deliveryDate}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default productionSchedule;
